import createChangedAdjEntry from './createChangedAdjEntry.js'
import getAdjCollectionKey from './getAdjCollectionKey.js'
import isAdjustmentChanged from './isAdjustmentChanged.js'
import getAdjPayloadIds from './getAdjPayloadIds.js'
import hasTempId from './hasTempId.js'
//-----------------------
// get adjustment changes
//------------------------
export default function getAdjChanges({ category, original_adjs, character }) {
  //
  console.log('-----------------------')
  console.log('IN getAdjChanges')
  //-------------------------------------------------------------
  // NB: processed once after all sheet changes prior to updates
  //-------------------------------------------------------------
  let changed_adjs = []
  const key = getAdjCollectionKey(category)
  const now_adjs = character?.[key] || []

  function isPersistedBySave(adj) {
    return adj?.editable === true || adj?.persistable === true
  }

  function resolveAdjCharacterItem(adj) {
    if (!adj) {
      return {
        rawCharacterItemId: null,
        characterItemId: null,
        itemLinkName: null,
      }
    }

    let rawCharacterItemId = null

    if (adj.character_item && typeof adj.character_item === 'object') {
      rawCharacterItemId = adj.character_item.id ?? null
    } else if (adj.character_item != null) {
      rawCharacterItemId = adj.character_item
    } else if (adj.item_id != null) {
      rawCharacterItemId = adj.item_id
    }

    let itemLinkName = null
    if (hasTempId(rawCharacterItemId) && Array.isArray(character.items)) {
      const charItem = character.items.find((ci) => ci.id === rawCharacterItemId)
      if (charItem) {
        itemLinkName =
          charItem.display_name && charItem.display_name !== ''
            ? charItem.display_name
            : (charItem.name ?? null)
      } else {
        console.error(
          'resolveAdjCharacterItem: could not find character item for temp id = ' +
            rawCharacterItemId,
        )
      }
    }

    return {
      rawCharacterItemId,
      characterItemId: hasTempId(rawCharacterItemId) ? null : rawCharacterItemId,
      itemLinkName,
    }
  }

  console.log('category = ' + category)
  console.log('now_adjs = ', now_adjs)
  console.log('original_adjs = ', original_adjs)
  //--------------------------------------------------------------------------------------
  // - original adjs can be null/empty (no adjs at load time)
  // - now adjs can be null/empty (all adjs deleted OR never has adjs in the first place)
  //--------------------------------------------------------------------------------------
  // loop through original adjs (for this category which are editable)
  //-------------------------------------------------------------------
  console.log('CHECKING ORIGINAL ADJS...')

  original_adjs.forEach((o) => {
    console.log('=============================================================')
    console.log('ORIGINAL ADJ = ', o)
    //----------------------------------------------------
    // find idx of orig adj in now adjs (for same source)
    //----------------------------------------------------
    const now_idx = now_adjs.findIndex((c) => c.id === o.id && c.source === o.source)
    console.log('now_idx = ', now_idx)
    console.log('now_idx adj = ', now_adjs[now_idx])
    //--------------------
    // adj remains in now
    //--------------------
    if (now_idx !== -1) {
      console.log('***** FOUND NOW ADJ = ', now_adjs[now_idx])
      console.log('1. ADJ STILL IN NOW: ' + o.name)
      //---------------------
      // check value changed
      //---------------------
      let adj_changed = isAdjustmentChanged(o, now_adjs[now_idx])
      console.log('CHANGED?? = ' + adj_changed)
      //---------------
      // value changed
      //---------------
      if (adj_changed) {
        console.log(
          '2. ADJ CHANGED - was adj value = ' +
            o.adj_value +
            ' now value = ' +
            now_adjs[now_idx].adj_value,
          ' was adj reason = ' + o.adj_reason + ' now reason = ' + now_adjs[now_idx].adj_reason,
        )
        //--------------------------------------
        // create changed adj entry (as UPDATE)
        //--------------------------------------
        console.log('adding UPDATE entry...')
        const resolvedCharacterItem = resolveAdjCharacterItem(now_adjs[now_idx])
        //------------------------------
        // base payload for all adjs
        //------------------------------
        let update_payload = {
          adj_reason: now_adjs[now_idx].adj_reason,
          adj_value: now_adjs[now_idx].adj_value,
          character_item: resolvedCharacterItem.characterItemId,
        }
        //----------------------------------------------
        // only skill adjs have an "applied" flag model
        //----------------------------------------------
        if (category === 'skill') {
          update_payload.applied = now_adjs[now_idx].applied
        }
        let changed_parm = createChangedAdjEntry({
          category: category,
          name: now_adjs[now_idx].name, // for debug + skill deletion check
          action: 'UPDATE',
          id: now_adjs[now_idx].id,
          payload: update_payload,
        })
        if (
          now_adjs[now_idx]?.backend_orchestrated_linked_value_preview === true ||
          now_adjs[now_idx]?.hydrated_recoverable_linked_value === true
        ) {
          changed_parm.backend_orchestrated_linked_value_preview = true
          changed_parm.backend_orchestrated_linked_value_parent_temp_id =
            now_adjs[now_idx]?.backend_orchestrated_linked_value_parent_temp_id ??
            now_adjs[now_idx]?.recoverable_item_temp_id ??
            null
          changed_parm.backend_orchestrated_linked_value_update_source =
            now_adjs[now_idx]?.backend_orchestrated_linked_value_update_source ?? 'recovery'
        }
        if (resolvedCharacterItem.itemLinkName) {
          changed_parm.character_item_link_name = resolvedCharacterItem.itemLinkName
        }
        changed_adjs.push(changed_parm)
        console.log('getAdjChanges changed_parm = ', changed_parm)
      } else {
        //----------------------
        // not changed - ignore
        //----------------------
        console.log('getAdjChanges ADJ NOT CHANGED: ' + o.id)
      }
      //-----------------
      // adj NOT in NOW
      //-----------------
    } else {
      console.log('getAdjChanges ADJ NO LONGER IN NOW: ' + o.id)
      //--------------------------------------
      // create changed adj entry (as DELETE)
      //--------------------------------------
      console.log('adding DELETE entry...')
      const resolvedCharacterItem = resolveAdjCharacterItem(o)
      let changed_parm = createChangedAdjEntry({
        category: category,
        name: o.name, // for debug only
        action: 'DELETE',
        id: o.id,
        payload: {
          character_item: resolvedCharacterItem.characterItemId,
        },
      })
      if (
        o?.backend_orchestrated_linked_value_preview === true ||
        o?.hydrated_recoverable_linked_value === true
      ) {
        changed_parm.backend_orchestrated_linked_value_preview = true
        changed_parm.backend_orchestrated_linked_value_parent_temp_id =
          o?.backend_orchestrated_linked_value_parent_temp_id ?? o?.recoverable_item_temp_id ?? null
        changed_parm.backend_orchestrated_linked_value_update_source =
          o?.backend_orchestrated_linked_value_update_source ?? 'recovery'
      }
      changed_adjs.push(changed_parm)
      console.log('getAdjChanges changed_parm = ', changed_parm)
    }
  })
  //================================================================
  // B. filter now adjs where id = null (new adjs)
  //-----------------------------------------------
  console.log('********************************************************')
  console.log('********************************************************')
  console.log('CHECKING FOR NEW ADJS (id = null) IN NOW ADJS')
  const new_adjs = now_adjs.filter((a) => a.id === null && isPersistedBySave(a))
  console.log('B1. new_adjs = ', new_adjs)
  //-----------------------------------------
  // create changed adj entries for new adjs
  //-----------------------------------------
  new_adjs.forEach((n) => {
    console.log('B2. NEW ADJ: ' + n.adj_value)
    //----------------------------------------------------------------------------------------------
    // NB: for adj linked to new character_item id will have a temp-id for frontend purposes.
    // This needs to be replaced by with item name to enable backend to resolve to real id on save.
    //----------------------------------------------------------------------------------------------
    console.log('n.character_item = ', n.character_item)
    const resolvedCharacterItem = resolveAdjCharacterItem(n)
    const item_link_name = resolvedCharacterItem.itemLinkName
    if (item_link_name) {
      console.log('B2c. item_link_name for adj = ', item_link_name)
    }
    //----------------------
    // declare base payload
    //----------------------
    let base_payload = {
      adj_reason: n.adj_reason,
      adj_value: n.adj_value,
      character_item: resolvedCharacterItem.characterItemId,
    }
    //----------------------------------------------
    // only skill adjs have an "applied" flag model
    //----------------------------------------------
    if (category === 'skill') {
      base_payload.applied = n.applied
    }
    console.log('B3. getAdjChanges base_payload = ', window.$deepCopy(base_payload))
    //------------------------------------------------------------
    // get relevent payload ids for category
    // NB: for adds only - other update/delete id outside payload
    //------------------------------------------------------------
    const adj_payload = getAdjPayloadIds({
      payload: base_payload,
      category,
      name: n.name,
      character,
    })
    console.log('B4. getAdjChanges adj_payload = ', window.$deepCopy(adj_payload))
    //-----------------------------------
    // create changed adj entry (as ADD)
    //-----------------------------------
    console.log('B5. adding ADD entry...')
    let changed_parm = createChangedAdjEntry({
      category: category,
      name: n.name, // for debug only
      action: 'ADD',
      id: null,
      payload: adj_payload,
    })
    if (
      n?.backend_orchestrated_linked_value_preview === true ||
      n?.hydrated_recoverable_linked_value === true
    ) {
      changed_parm.backend_orchestrated_linked_value_preview = true
      changed_parm.backend_orchestrated_linked_value_parent_temp_id =
        n?.backend_orchestrated_linked_value_parent_temp_id ?? n?.recoverable_item_temp_id ?? null
      changed_parm.backend_orchestrated_linked_value_update_source =
        n?.backend_orchestrated_linked_value_update_source ?? 'recovery'
    }
    //-----------------------------------------
    // preserve pending item link (by name) so
    // harness can resolve to character_item id
    //-----------------------------------------
    if (item_link_name) {
      changed_parm.character_item_link_name = item_link_name
    }
    changed_adjs.push(changed_parm)
    console.log('B6. getAdjChanges changed_parm = ', window.$deepCopy(changed_parm))
    console.log('B7. getAdjChanges changed_adjs = ', window.$deepCopy(changed_adjs))
    console.log('********************************************************')
  })
  return changed_adjs
}
